export const tierCodesOptions = {
  1: [""],
  2: ["1", "2"],
  3: ["1", "2", "3"],
  4: ["1", "2", "3", "4"],
  5: ["1a", "1b", "2", "3", "4"],
};

export const tierNamesOptions = {
  1: [""],
  2: ["Generic", "Brand"],
  3: ["Generic", "Brand", "Specialty"],
  4: ["Generic", "Preferred Brand", "Non-Preferred Brand", "Specialty"],
  5: ["Preferred Generic", "Non-Preferred Generic", "Preferred Brand", "Non-Preferred Brand", "Specialty"],
};

export const pharmacyTypesOptions = {
  1: ["Retail"],
  2: ["Retail", "Mail Order"],
  4: ["Preferred Retail", "Standard Retail", "Preferred Mail Order", "Standard Mail Order"],
};

export const maxSupplyOptions = {
  1: ["30-day"],
  2: ["30-day", "90-day"],
  4: ["30-day", "30-day", "90-day", "90-day"],
};

export const frequencyOptions = [
  {
    value: "monthly",
    name: "Monthly",
  },
  {
    value: "quarterly",
    name: "Quarterly",
  },
];

export const separateOrCombinedOptions = [
  {
    value: "separate",
    name: "Separate",
  },
  {
    value: "combined",
    name: "Combined with Medical",
  },
];

export const yesOrNoOptions = [
  {
    value: true,
    name: "Yes",
  },
  {
    value: false,
    name: "No",
  },
];

export const coverageOptions = [
  {
    value: "coinsurance",
    name: "Coinsurance",
  },
  {
    value: "copay",
    name: "Copay",
  },
];
